/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomEliteConfigurationModelDto } from '../../models/custom-elite-configuration-model-dto';

export interface CustomEliteConfigurationControllerCreateConfiguration$Params {
      body: CustomEliteConfigurationModelDto
}

export function customEliteConfigurationControllerCreateConfiguration(http: HttpClient, rootUrl: string, params: CustomEliteConfigurationControllerCreateConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomEliteConfigurationModelDto>> {
  const rb = new RequestBuilder(rootUrl, customEliteConfigurationControllerCreateConfiguration.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomEliteConfigurationModelDto>;
    })
  );
}

customEliteConfigurationControllerCreateConfiguration.PATH = '/custom-elite-configuration';
